import { render, staticRenderFns } from "./EditPurchaseOrderModal.vue?vue&type=template&id=6b96f1de&scoped=true"
import script from "./EditPurchaseOrderModal.vue?vue&type=script&lang=js"
export * from "./EditPurchaseOrderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96f1de",
  null
  
)

export default component.exports